<template lang="pug">
  b-modal#createRoom(
    ref="createRoom"
    :title="$t('ui.create_room')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="xl"
    @ok="done"
    @show="reset"
  )
    b-row.create-room-container
      .col-sm-12
        panel.mb-0(:title='$t("ui.match_selection")')
          b-row
            .col-sm-6.py-0.pl-0
              b-card
                b-row.flex(slot="header")
                  .col-sm-12.col-md-12.col-lg-12
                    b-input-group(:prepend="$t('ui.league')" size="sm")
                      DebounceInput(
                        type="text"
                        ref="league"
                        :placeholder='$t("ui.league")'
                        v-model="league"
                        size="sm"
                        @keyup.enter.native="getLeagueLookup"
                      )
                  .col-sm-12.col-md-12.col-lg-12.col-xl-12.mt-1
                    SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="getLeagueLookup")
                b-row
                  .col-sm-12.col-md-8.col-lg-9.col-xl-8.mb-1
                    b-pagination(size="sm" :total-rows="totalRowsLeague" :per-page="perPageLeague" v-model="currentPageLeague" @input="getLeagueLookup")
                  .col-sm-12.col-md-4.col-lg-3.col-xl-4.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="perPageLeague" @input="changedPageSizeLeague")
                  .col-sm-12.col-md-12.col-lg-12.col-xl-12
                    b-table#tblList.table-sm.table-hover.table-bordered.height01.mb-0(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="leagueList" :fields="fieldsLeague" thead-class="grey" select-mode="single" :tbody-tr-class="rowClass" @row-clicked="onRowClicked")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(selected_league)="row")
                        label.btn-radio.d-flex.mb-0.pointer
                          input(
                            type="radio"
                            id=""
                            v-model="selectedLeague"
                            style="pointer-events: none;"
                            :value="row.item.league_id")
            .col-sm-6.p-0
              b-card
                b-row.flex(slot="header")
                  .col-sm-12.col-md-12.col-lg-6
                    b-input-group(:prepend="$t('ui.home')" size="sm")
                      DebounceInput(
                        type="text"
                        ref="home"
                        :placeholder='$t("ui.home")'
                        v-model="home"
                        size="sm"
                      )
                  .col-sm-12.col-md-12.col-lg-6
                    b-input-group(:prepend="$t('ui.away')" size="sm")
                      DebounceInput(
                        type="text"
                        ref="away"
                        :placeholder='$t("ui.away")'
                        v-model="away"
                        size="sm"
                      )
                  .col-sm-12.col-md-12.col-lg-12.col-xl-12.mt-1
                    SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="getMatchLookup")
                b-row
                  .col-sm-12.col-md-8.col-lg-9.col-xl-8.mb-1
                    b-pagination(size="sm" :total-rows="totalRowsMatch" :per-page="perPageMatch" v-model="currentPageMatch" @input="getMatchLookup")
                  .col-sm-12.col-md-4.col-lg-3.col-xl-4.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="perPageMatch" @input="changedPageSizeMatch")
                  .col-sm-12.col-md-12.col-lg-12.col-xl-12
                    b-table#tblList.table-sm.table-hover.table-bordered.height01.mb-0(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="matchList" :fields="fieldsMatch" thead-class="grey" :tbody-tr-class="rowClassMatch" select-mode="multi" @row-clicked="onRowClickedMatch")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(match_time)="row")
                        span {{ $moment(row.item.match_time).format("DD/MM/YYYY HH:mm") }}
                      template(v-slot:cell(checked)="row")
                        input.mt-1(
                          type="checkbox"
                          style="pointer-events: none;"
                          v-model="row.item.checked"
                          )
          b-row.mt-2.float-right
            SubmitButton(:loading="loading" icon="fa fa-plus" :text="$t('ui.insert')" isModal=false type="button" @click="insertMatch")
      .col-sm-12
        panel.mb-0(:title='$t("ui.selected_match") + " (" + matchSelectedList.length + "/" + maxMatch + ")"')
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover.table-bordered.height01.mb-0(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="matchSelectedList" :fields="fieldsMatchSelected" thead-class="grey")
                template(v-slot:cell(index)="row")
                  span {{ row.index + 1 }}
                template(v-slot:cell(match_time)="row")
                  span {{ $moment(row.item.match_time).format("DD/MM/YYYY HH:mm") }}
                template(v-slot:cell(delete)="row")
                  a.pointer.d-inline-block(href="#" @click="deleteMatchSelected(row.item, row.index)")
                    i.fas.fa-trash.pointer.delete-btn
      .col-sm-12
        b-row.flex
          .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
            b-input-group(:prepend="$t('ui.currency')" size="sm")
              input.form-control.create-room(
                type="text"
                disabled
                v-model="currency")
          .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
            b-input-group(:prepend="$t('ui.entry_points')" size="sm")
              b-form-select(
                ref="roomRate"
                v-model="roomRate"
                :options="roomRateList"
                size="sm"
              )
          .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
            b-input-group(:prepend="$t('ui.players')" size="sm")
              b-form-select(
                ref="roomLimit"
                v-model="roomLimit"
                :options="roomLimitList"
                size="sm"
              )
          .col-sm-12.col-md-6.col-lg-6.col-xl-5.mb-1
            b-input-group(:prepend="$t('ui.room_type')" size="sm")
              b-form-select.mr-3(
                ref="room_type"
                v-model="roomType"
                :options="roomTypeList"
                size="sm"
              )
              b-form-select.mr-3(
                ref="pay_type"
                v-model="payType"
                :options="payTypeList"
                size="sm"
              )
              b-form-select(
                ref="formula"
                v-model="formula"
                :options="formulaList"
                size="sm"
              )

    .form-group
      b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)

</template>

<script>
import SubmitButton from "@/library/SubmitButton"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      leagueList: [],
      league: "",
      currentPageLeague: 1,
      totalRowsLeague: 0,
      perPageLeague: 10,
      selectedLeague: null,
      matchList: [],
      home: "",
      away: "",
      currentPageMatch: 1,
      totalRowsMatch: 0,
      perPageMatch: 10,
      matchSelectedList: [],
      maxMatch: 20,
      roomRate: 100,
      roomRateList: [{
        value: 20,
        text: 20
      },
      {
        value: 50,
        text: 50
      },
      {
        value: 100,
        text: 100
      },
      {
        value: 200,
        text: 200
      },
      {
        value: 500,
        text: 500
      },
      {
        value: 1000,
        text: 1000
      },],
      roomLimit: 10,
      roomLimitList: [{
        value: 3,
        text: 3
      },
      {
        value: 4,
        text: 4
      },
      {
        value: 5,
        text: 5
      },
      {
        value: 6,
        text: 6
      },
      {
        value: 7,
        text: 7
      },
      {
        value: 8,
        text: 8
      },
      {
        value: 9,
        text: 9
      },
      {
        value: 10,
        text: 10
      },
      {
        value: 12,
        text: 12
      },
      {
        value: 14,
        text: 14
      },
      {
        value: 16,
        text: 16
      },
      {
        value: 18,
        text: 18
      },
      {
        value: 20,
        text: 20
      },
      {
        value: 30,
        text: 30
      },
      {
        value: 40,
        text: 40
      },
      {
        value: 50,
        text: 50
      },
      {
        value: 80,
        text: 80
      },
      {
        value: 100,
        text: 100
      },],
      currency: this.$store.getters.getAccountCurrency,
      roomType: 1,
      roomTypeList: [{
        value: 1,
        text: this.$t("ui.public")
      },
      {
        value: 3,
        text: this.$t("ui.public_free")
      }],
      payType: 2,
      payTypeList: [
      // {
      //   value: 1,
      //   text: this.$t("ui.basic")
      // },
      {
        value: 2,
        text: this.$t("ui.plus")
      }],
      formula: 1,
      formulaList: [{
        value: 1,
        text: this.$t("ui.three_winner")
      },
      {
        value: 2,
        text: this.$t("ui.one_winner")
      }]
    }
  },
  computed: {
    fieldsLeague() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "name_en",
          label: this.$t("ui.league"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "85%"
          }
        },
        {
          key: "selected_league",
          label: "",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        }
      ];
    },
    fieldsMatch() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "match_time",
          label: this.$t("ui.match_time"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "home_name",
          label: this.$t("ui.home"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "35%"
          }
        },
        {
          key: "away_name",
          label: this.$t("ui.away"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "35%"
          }
        },
        {
          key: "checked",
          label: "",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        }
      ];
    },
    fieldsMatchSelected() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "match_time",
          label: this.$t("ui.match_time"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "league_name",
          label: this.$t("ui.league"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "40%"
          }
        },
        {
          key: "home_name",
          label: this.$t("ui.home"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "away_name",
          label: this.$t("ui.away"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "delete",
          label: "",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        }
      ];
    }
  },
  methods: {
    changedPageSizeLeague: function(pageSize) {
      this.perPageLeague = pageSize;
      this.currentPageLeague = 1
      this.getLeagueLookup()
    },
    changedPageSizeMatch: function(pageSize) {
      this.perPageMatch = pageSize;
      this.currentPageMatch = 1
      this.getMatchLookup()
    },
    errorAlert(text) {
      this.$swal({
        title: "",
        text: text,
        type: "error",
        allowOutsideClick: false
      });
    },
    rowClass(item, type) {
      var className = "create-room-pointer";

      if(item && type == "row") {
        if(item.league_id == this.selectedLeague)
          className += " selected-row"
      }

      return className;
    },
    rowClassMatch(item, type) {
      var className = "";

      if(item && type == "row") {
        if(item.checked == true)
          className += " selected-row"

        if(item.inserted == true)
          className += " inserted-row"
        else
          className += " create-room-pointer"
      }

      return className;
    },
    onRowClicked(item) {
      this.selectedLeague = item.league_id;
      this.home = ""
      this.away = ""
      this.matchList = []
      this.getMatchLookup();
    },
    onRowClickedMatch(item) {
      if(item.inserted == true)
        return;
      item.checked = !item.checked;
      this.$forceUpdate();
    },
    getLeagueLookup() {
      this.home = ""
      this.away = ""
      this.matchList = []
      this.selectedLeague = null
      let name_en = this.league
      let page_number = this.currentPageLeague;
      this.currentPageLeague = parseInt(page_number);
      let page_size = this.perPageLeague;
      this.loading = true
      this.$store
        .dispatch("user/getTournamentLeagueLookup", { name_en, page_number, page_size })
        .then(response => {
          this.loading = false
          if(response.success == true){
            this.leagueList = response.data
            this.totalRowsLeague = response.data.length > 0 ? this.leagueList[0]["totalrows"] : 0;
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    getMatchLookup() {
      let league_id = this.selectedLeague
      let home_team_name = this.home
      let away_team_name = this.away
      let page_number = this.currentPageMatch;
      this.currentPageMatch = parseInt(page_number);
      let page_size = this.perPageMatch;
      this.loading = true
      this.$store
        .dispatch("user/getTournamentMatchLookup", { league_id, home_team_name, away_team_name, page_number, page_size })
        .then(response => {
          this.loading = false
          if(response.success == true){
            var value = response.data

            var tempMatch = {}
            for(var i = 0; i < this.matchSelectedList.length; i++) {
              tempMatch[this.matchSelectedList[i].match_id] = this.matchSelectedList[i].inserted
            }

            if(value != undefined) {
              for(var i = 0; i < value.length; i++) {
                if(tempMatch[value[i].match_id] != undefined) {
                  value[i].inserted = tempMatch[value[i].match_id]
                } else {
                  value[i].inserted = false
                }
              }
            }

            if(value != undefined)
              this.matchList = value
            else
              this.matchList = []

            this.totalRowsMatch = response.data.length > 0 ? this.matchList[0]["totalrows"] : 0;
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    insertMatch() {
      var haveMatch = false;
      for(var i = 0; i < this.matchList.length; i++) {
        if(this.matchList[i].checked == true) {
          haveMatch = true;
          if(this.matchSelectedList.length >= 20) {
            this.errorAlert(this.$t("message.max_selected_match", { max: this.maxMatch}));
            break;
          }
          this.matchSelectedList.push(this.matchList[i]);
          this.matchList[i].checked = false;
          this.matchList[i].inserted = true;
        }
      }

      if(!haveMatch) {
        this.errorAlert(this.$t("message.select_match"));
      }
    },
    deleteMatchSelected(info, index) {
      this.matchSelectedList.splice(index, 1);

      if(this.selectedLeague == info.league_id) {
        this.matchList.filter(x=>x.match_id===info.match_id)[0].inserted = false;
      }
    },
    done: function(evt) {
      evt.preventDefault()
      this.submit();
    },
    submit() {
      if(this.matchSelectedList.length <= 0) {
        this.errorAlert(this.$t("error.no_match_selected"));
        this.loading = false
        return;
      }

      this.loading = true
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.create_room_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.addRoom()
        } else if (
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.create_room_cancel"),
            type: "error",
            allowOutsideClick: false
          });
        }
      });
    },
    addRoom() {
      let room_rate = this.roomRate
      let room_limit = this.roomLimit
      let room_type = this.roomType
      let pay_type = this.payType
      let formula = this.formula
      let match = [];

      for(var i = 0; i < this.matchSelectedList.length; i++) {
        match.push({
          a: this.matchSelectedList[i].match_id
        });
      }
      match = JSON.stringify(match);

      this.$store
        .dispatch("user/createTournamentPublicRoom", { room_rate, room_limit, room_type, pay_type, formula, match })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.create_room_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          this.loading = false;
          this.submission.success = response.success
          let result = response.errorTag.includes("createRoomFailed");
          if(!result)
            this.submission.status = this.$t("message." + response.errorTag)
          else
            this.submission.status = this.$t("message.createRoomFailed")
        });
    },

    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.leagueList = []
      this.league = ""
      this.currentPageLeague = 1
      this.totalRowsLeague = 0
      this.perPageLeague = 10
      this.selectedLeague = null
      this.matchList = []
      this.home = ""
      this.away = ""
      this.currentPageMatch = 1
      this.totalRowsMatch = 0
      this.perPageMatch = 10
      this.matchSelectedList = []
      this.roomRate = 100
      this.roomLimit = 10
      this.currency = this.$store.getters.getAccountCurrency
      this.roomType = 1
      this.loading = false
      this.payType = 2
      this.formula = 1
    },
    cancel: function() {
      this.reset()
      this.$emit("clicked")
      this.$refs.createRoom.hide()
    }
  }
};
</script>

<style lang="scss">
.create-room-container .panel-heading {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.create-room-container .card-header {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.create-room-container .selected-row {
  background-color: #dedede !important;
}

.create-room-container .height01 {
  height: calc(100vh - 790px);
}
.create-room-container .create-room-pointer {
  cursor: pointer;
}
.create-room-container .inserted-row {
  background: #feed1f;
}
.create-room-container .delete-btn {
  color: red;
}
</style>
